import React, { useEffect, useState } from "react";
import style from "./users.module.scss";
import Skeleton from "../skeleton/skeleton"
{/* <Skeleton type='rectangle' width='280px' height='44px' /> */ }
const UserSkeleton = (props) => {

    return <div className={style.wrapper}>
        <div className={style.header}>
            <h1><Skeleton type='rectangle' width='96px' height='44px' /></h1>
            <div className={style.buttonsWrapper}>
                <div className={style.addUser}>
                    <Skeleton type='rectangle' width='114px' height='44px' />
                </div>
            </div>
        </div>
        <div className={style.searchbarWrapper}>
            <Skeleton type='rectangle' width='100%' height='48px' />
        </div>
        <div className={style.container}><Skeleton type='rectangle' width='100%' height='80px' /></div>
        <div className={style.container}><Skeleton type='rectangle' width='100%' height='80px' /></div>
        <div className={style.container}><Skeleton type='rectangle' width='100%' height='80px' /></div>
        <div className={style.container}><Skeleton type='rectangle' width='100%' height='80px' /></div>
    </div>
}
export default UserSkeleton;
